import { Controller, useFormContext } from 'react-hook-form'

import { FF2, SecuredInput, Validators } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

export const TIN = () => {
  const { control } = useFormContext<SarEdit>()

  return (
    <Controller
      name="institutionContactInfo.tin"
      control={control}
      rules={{ validate: Validators.required.field }}
      render={({ field }) => (
        <FF2
          required
          label="77. TIN"
          field={field}
          input={(props) => <SecuredInput {...props} maxLength={25} data-qa="77. TIN" />}
        />
      )}
    />
  )
}
